/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { useMemo } from "react";

export const useAuthConfig = () => {
    const origin = window.location.origin;

    const authConfig = useMemo(() => {
        if (/dev?\.viacal-dev\.ridewithvia\.com/.test(origin)) {
            return DEV_AUTH_CONFIGS;
        }
        if (/eu1?\.viacal\.ridewithvia\.com/.test(origin)) {
            return EU1_AUTH_CONFIGS;
        }
        if (/us1?\.viacal\.ridewithvia\.com/.test(origin)) {
            return US1_AUTH_CONFIGS;
        }
        if (/cace1?\.viacal\.ridewithvia\.com/.test(origin)) {
            return CACE1_AUTH_CONFIGS;
        }

        return DEV_AUTH_CONFIGS;
    }, [origin]);

    return { authConfig };
};

export const DEV_AUTH_CONFIGS = {
    region: "us-east-1",
    cognitoClientId: "6es3jepdk7hpfmqrmr4sjqg5kq",
};
export const US1_AUTH_CONFIGS = {
    region: "us-east-1",
    cognitoClientId: "29orqpgttkaju0ajkah5r53jj8",
};
export const EU1_AUTH_CONFIGS = {
    region: "eu-west-1",
    cognitoClientId: "3c89plhtrnvqotvleja7fnbdrf",
};
export const CACE1_AUTH_CONFIGS = {
    region: "ca-central-1",
    cognitoClientId: "rbh2j4ns97kdvv724njuf8que",
};
